module.exports = __webpack_public_path__ + "img/user.e0d4ebca.png";